<script setup>
const isOpen = ref(false);

const props = defineProps({
  customActions: {
    type: Boolean,
    default: false,
  },
  modalOpen: {
    type: Boolean,
  },
  closeText: {
    type: [String, Number],
  },
  successText: {
    type: [String, Number],
  },
  width: {
    type: [String, Number],
  },
  maxWidth: {
    type: [String, Number],
  },
  disableSuccess: {
    type: Boolean,
  },
  disableButtons: {
    type: Boolean,
  },
  contentBackground: {
    type: String,
    default: () => 'transparent',
  },
  backgroundHeader: {
    type: String,
    default: () => '#f5f5f5',
  },
  hideHeader: {
    type: Boolean,
    default: () => false,
  },
});

const { modalOpen } = toRefs(props);

const emit = defineEmits(['close', 'success']);

watch(modalOpen, (val) => {
  isOpen.value = val;
});

watch(isOpen, (value) => {
  if (!value) {
    emit('close');
  }
});
</script>

<template>
  <v-dialog :max-width="maxWidth ? maxWidth : '30%'" min-width="200px" v-model="isOpen">
    <v-card>
      <v-card-title
        v-if="!hideHeader"
        :style="`border-bottom: 1px solid #cacaca; background-color: ${backgroundHeader}`"
      >
        <slot name="header"></slot>
      </v-card-title>
      <v-card-text :style="`background-color: ${contentBackground}`">
        <slot></slot>
      </v-card-text>
      <v-card-actions v-if="!disableButtons">
        <v-row no-gutters class="pr-8 pb-4" justify="end">
          <slot name="buttons"></slot>
          <v-btn
            v-if="closeText && !customActions"
            color="success"
            @click="$emit('close')"
            class="text-transform-none"
            >{{ closeText }}</v-btn
          >
          <v-btn
            color="success"
            variant="elevated"
            v-if="successText && !customActions"
            @click.prevent.stop="$emit('success')"
            :disabled="disableSuccess"
            class="text-transform-none"
            >{{ successText }}</v-btn
          >
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
